import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';

@Injectable({
  providedIn: 'root',
})
export class HasAdminRoleGuard {
  private whoami = inject(WhoAmIService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.whoami.isAdmin()) {
      return of(true);
    } else {
      this.router.navigate(['']);
      return of(false);
    }
  }
}
